import React from 'react';
import {EmployeeSchedule} from '@gakki/api/types';
import {CustomIconButton} from '@common/components/Button';

type ShiftBindingItemProps = {
  item: EmployeeSchedule;
  idx: number;
  onRemove: (id: string) => void;
  onEdit: (item: EmployeeSchedule) => void;
  deletable?: boolean;
};
function ShiftBindingItem({
  item,
  idx,
  onRemove,
  onEdit,
  deletable = true,
}: ShiftBindingItemProps) {
  return (
    <fieldset
      className={
        'grid grid-cols-[55px,1fr] w-full py-5 pr-4 border-b border-b-[#d5dadd]'
      }
      data-test-id={`shift-binding-${idx}`}
    >
      <h5
        className={
          'col-start-1 col-end-2 row-start-1 row-end-4 justify-self-center m-0'
        }
      >
        {(idx + 1).toString().padStart(2, '0')}
      </h5>
      <h4
        className={
          'col-start-2 col-end-6 text-[15px] flex justify-between items-center border-b border-b-[#d4d9dc] pb-[5px] mb-2'
        }
      >
        {item.shift.shiftName}
        <div className={'flex items-center'}>
          {deletable && (
            <CustomIconButton
              onClick={() => onRemove(item.id)}
              data-test-id={'remove-btn'}
              icon="trash"
            />
          )}
          <CustomIconButton
            onClick={() => onEdit(item)}
            data-test-id={'edit-btn'}
            icon="edit"
          />
        </div>
      </h4>
      <div className={'grid grid-cols-[auto,1fr] gap-y-2 gap-x-[25px] mb-0'}>
        <div>適用單位</div>
        <div data-test-id={'applied-unit'}>
          {(function () {
            switch (item.appliedUnit) {
              case 'Company':
                return '公司';
              case 'Employee':
                return '人員';
              case 'Organization':
                return '部門';
            }
          })()}
        </div>
        <div className={'col-start-1 col-end-2'}>適用對象</div>
        <ul
          className={'m-0 p-0 flex gap-[10px] flex-wrap col-start-2 col-end-5'}
        >
          {item.units?.map(u => (
            <li
              className={
                'inline-block bg-[#353d45] text-white py-[3px] px-[10px]'
              }
              data-test-id={'unit-name'}
            >
              {u.name}
            </li>
          ))}
        </ul>
      </div>
    </fieldset>
  );
}

export default ShiftBindingItem;
